import * as z from 'zod';
import { optional, timestampSchema } from './common';

// Merchant Service — `v1Merchant`, the company that owns one or more
// restaurants (branches).

export const merchantSchema = z.object({
  id: z.string(),
  name: z.string().default(''),
  /** Free-form on the wire (observed: `active`); not a proto enum. */
  status: z.string().default(''),
  created_at: optional(timestampSchema),
  updated_at: optional(timestampSchema),
});
export type Merchant = z.infer<typeof merchantSchema>;

/** Single-resource payload — `data` on get/create/update. */
export const merchantResponseSchema = z.object({
  merchant: merchantSchema,
});

export const merchantCapabilityKeySchema = z.enum([
  'restaurant.create',
  'product_category.create',
  'product.create',
  'restaurant_product.add',
  'modifier_group.create',
  'modifier_option.create',
  'promotion.create',
  'promotion.add_products',
  'banner_product.create',
  'banner_restaurant.create',
]);
export type MerchantCapabilityKey = z.infer<typeof merchantCapabilityKeySchema>;

export const merchantCapabilitySchema = z.object({
  allowed: z.boolean(),
  reason: z.string().default(''),
});
export type MerchantCapability = z.infer<typeof merchantCapabilitySchema>;

export const merchantCapabilitiesSchema = z.object({
  capabilities: z.record(z.string(), merchantCapabilitySchema),
  menu_source: z.string().default(''),
});
export type MerchantCapabilities = z.infer<typeof merchantCapabilitiesSchema>;
